/**
 * @generated SignedSource<<9c5920d5c64cf7d2a4bfc4c42545752d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priority_nativeIssueTable_PriorityCell$data = {
  readonly priority: {
    readonly iconUrl: AGG$URL | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"priority_nativeIssueTable_PriorityCellInternal_fieldRef">;
  readonly " $fragmentType": "priority_nativeIssueTable_PriorityCell";
};
export type priority_nativeIssueTable_PriorityCell$key = {
  readonly " $data"?: priority_nativeIssueTable_PriorityCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"priority_nativeIssueTable_PriorityCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "priority_nativeIssueTable_PriorityCell",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "priority_nativeIssueTable_PriorityCellInternal_fieldRef"
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "29fcba618b61ab9cfc7738cee73c3760";

export default node;
